import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending4"><Path d="M2.5 4.5V19.5H21.5M5.5 16.5L11 11L13 13L19.2513 6.74872M15.5 6.5H19.5V10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending4;
